import React from "react";
import theme from "../../config/theme";
import { useSelector } from "react-redux";

interface TextAreaProps {
  name?: string;
  value?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  rows?: number;
  maxLength?: number;
  className?: string;
  error?: string;
  helperText?: string;
}

const TextArea: React.FC<TextAreaProps> = ({
  name,
  value,
  onChange,
  onBlur,
  placeholder = "متن خود را اینجا بنویسید...",
  disabled = false,
  required = false,
  rows = 4,
  maxLength,
  className = "",
  error,
  helperText,
}) => {
  const { theme: themeMode } = useSelector((state: any) => state.globalState);
  const mode = themeMode === "light" ? theme.light : theme.dark;
  return (
    <>
      <div className={`relative ${className}`}>
        <textarea
          style={{ backgroundColor: mode.backgroundColor.bgPrimary }}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          rows={rows}
          maxLength={maxLength}
          className={`border rounded-md p-2 w-full resize-none focus:outline-none focus:bg-white focus:border-[#028d91] focus:shadow-[0_0px_4px_#03797d73] ${
            disabled ? "bg-gray-200 cursor-not-allowed" : "bg-white"
          } ${error ? "border-red-500" : "border-[#9D9D9D]"}`}
        />
        {maxLength && (
          <div className="absolute right-2 bottom-1 text-gray-500 text-sm">
            {value ? value.length : 0}/{maxLength}
          </div>
        )}
      </div>
      {(helperText || error) && (
        <p className="text-right w-full text-[9px] text-mobasher-red mt-1">
          * {error || helperText}
        </p>
      )}
    </>
  );
};

export default TextArea;
